import { SearchResponse } from "@/shared/types/type/search"
import { create } from "zustand"

interface TreatmentFilterStore {
  selectedTreatmentDisplayName: string
  setSelectedTreatmentDisplayName: (selectedTreatmentDisplayName: string) => void
  searchResultList: SearchResponse[]
  setSearchResultList: (searchResultList: SearchResponse[]) => void
}
const useTreatmentFilterStore = create<TreatmentFilterStore>((set) => ({
  selectedTreatmentDisplayName: "",
  setSelectedTreatmentDisplayName: (selectedTreatmentDisplayName: string) => set({ selectedTreatmentDisplayName }),
  searchResultList: [],
  setSearchResultList: (searchResultList: SearchResponse[]) => set({ searchResultList }),
}))

export default useTreatmentFilterStore
